import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { camps } from '../../../models/models.generated';

@Component({
    selector: 'app-membership-list-row',
    templateUrl: './membership-list-row.component.html',
    styleUrls: ['./membership-list-row.component.scss'],
    standalone: false
})
export class MembershipListRowComponent implements OnInit {
    @Input() public item: camps.MembershipDetails;

    @Output() addNoLimitRequested = new EventEmitter<camps.ChildDetails>();
    @Output() removeNoLimitRequested = new EventEmitter<camps.ChildDetails>();

    constructor() {}

    ngOnInit() {}

    onAddNoLimit(child: camps.ChildDetails) {
        this.addNoLimitRequested.emit(child);
    }

    onRemoveNoLimit(child: camps.ChildDetails) {
        this.removeNoLimitRequested.emit(child);
    }

    get hasChildren(){
        return this.item.children && this.item.children.length > 0;
    }
}
